"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = __importDefault(require("../styles/theme"));
const typography = (props) => ({
    color: props.color || theme_1.default.colors.textDefault,
    fontSize: props.fontSize !== undefined
        ? theme_1.default.font.size[props.fontSize].fontSize
        : undefined,
    fontWeight: props.fontWeight && theme_1.default.font.weight[props.fontWeight],
    lineHeight: props.fontSize !== undefined
        ? theme_1.default.font.size[props.fontSize].lineHeight
        : undefined,
});
exports.Text = styled_components_1.default.span `
  ${typography}
`;
exports.default = exports.Text;
